import "./style/index.scss";
import moment from "moment";
import { Image } from "antd";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import icon from "../../../../util/assets/icon_login.png";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import { LancamentoBancarioModel } from "../../../../models/lancamentoBancario/lancamentoBancarioModel";
import React from "react";
import { DetalhesFiltrosModel } from "../../../../models/detalhesFiltrosModel";

moment.locale("pt-br");

const LancamentoBancarioRelatorio = () => {
  //estados globais
  const lancamentoBancarioState_busca = JSON.parse(localStorage.getItem("lancamentoBancarioState_busca")!);

  const part1 = JSON.parse(localStorage.getItem("lancamentoBancarioState_part1") || "[]");
  const part2 = JSON.parse(localStorage.getItem("lancamentoBancarioState_part2") || "[]");
  const part3 = JSON.parse(localStorage.getItem("lancamentoBancarioState_part3") || "[]");
  const lancamentoBancarioState_list = [...part1, ...part2, ...part3];

  const empresaState = JSON.parse(localStorage.getItem("empresaState")!);
  const configuracoesState = JSON.parse(localStorage.getItem("configuracoesState")!);

  const RelatorioHtml = React.forwardRef<HTMLDivElement>((_props, ref) => {
    return (
      <>
        <div ref={ref} className="relatorios-html-format">
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", gap: "24px" }}>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", marginTop: "24px", marginBottom: "24px", marginLeft: "14px" }}>
              <Image preview={false} height={50} src={icon} />
              <div className={"logoText"}>
                <div className="labelLogoGeral">
                  <span>GRUPO</span>
                </div>
                <div className="labelLogoGeral">
                  <span>PASCHOAL</span>
                </div>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", marginTop: "24px", marginBottom: "24px" }}>
              <div style={{ fontSize: "14px", fontWeight: "bold" }}>RELATÓRIO DE LANÇAMENTOS</div>
              <div style={{ fontSize: "13px", marginTop: "10px" }}>
                <div style={{ display: "flex", gap: 4 }}>
                  <span style={{ fontWeight: "bold" }}>{`Data de ${lancamentoBancarioState_busca.tipoDataFiltro === "SORT" ? "Sorteio" : "Vencimento"}:`}</span>
                  <>{`entre ${moment(lancamentoBancarioState_busca.dataInicio).format("DD/MM/YYYY")} e ${moment(lancamentoBancarioState_busca.dataFim).format("DD/MM/YYYY")}`}</>
                </div>
              </div>
              <div style={{ fontSize: "13px" }}>
                <span style={{ fontWeight: "bold" }}>Empresa:</span> {empresaState.list.filter((a: EmpresaModel) => a.id === parseInt(lancamentoBancarioState_busca.idEmpresa.toString()))[0].apelido}
              </div>
              {configuracoesState.filtros.length > 0 && (
                <div style={{ fontSize: "12px", marginTop: "5px" }}>
                  <div style={{ fontWeight: "bold" }}>Filtros avançados:</div>
                  {configuracoesState.filtros.map((a: DetalhesFiltrosModel, index: any) => {
                    return (
                      <div key={index}>
                        {index + 1 + ". " + a.campo} <strong style={{ fontStyle: "italic" }}>{a.operador}</strong> {a.campo === "Valor" ? currencyBRL(a.valor) : a.valor}
                        {a.valor2 && " e ".concat(currencyBRL(a.valor2))}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
          <div className="rel-detalhe-lancamento">
            <table className="tb-dados">
              <thead>
                <tr className="header-table">
                  <th className="ht-right">DATA</th>
                  <th className="ht-left">CLIENTE/FORNECEDOR</th>
                  <th className="ht-left">N. DOC.</th>
                  <th className="ht-left">HISTÓRICO</th>
                  <th className="ht-right">VALOR</th>
                  <th className="ht-right">SALDO</th>
                </tr>
              </thead>
              <tbody className="body-table">
                {lancamentoBancarioState_list.map((a: LancamentoBancarioModel, index: any) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td className="ht-right">{a.tipoLancamento.includes("SALDO") ? a.tipoLancamento : moment(a.data).format("DD/MM/YYYY")}</td>
                      <td className="ht-left" style={{ whiteSpace: "break-spaces" }}>
                        {a.clienteFornecedor}
                      </td>
                      <td className="ht-left">{a.numeroDocumento}</td>
                      <td className="ht-left" style={{ whiteSpace: "break-spaces" }}>
                        {a.historico}
                      </td>
                      {a.es < 0 ? (
                        <td className="ht-right" style={{ color: "red" }}>
                          {a.valorTransacao !== null ? currencyBRL(a.valorTransacao) : a.valorTransacao}
                        </td>
                      ) : (
                        <td className="ht-right" style={{ color: "#334155" }}>
                          {a.valorTransacao !== null ? currencyBRL(a.valorTransacao) : a.valorTransacao}
                        </td>
                      )}
                      {a.saldo < 0 ? (
                        <td className="ht-right" style={{ color: "red" }}>
                          {a.saldo !== null ? currencyBRL(a.saldo) : null}
                        </td>
                      ) : (
                        <td className="ht-right" style={{ color: "#334155" }}>
                          {a.saldo !== null ? currencyBRL(a.saldo) : null}
                        </td>
                      )}
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  });

  return <RelatorioHtml />;
};

export default LancamentoBancarioRelatorio;
